export const headers = [
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'CPF', field: 'cpf', sortable: false },
  { name: 'Telefone', field: 'phone_number', sortable: false },
  { name: 'Chave PIX', field: 'pix_key', sortable: false },
  {
    name: 'Comissão por contrato',
    field: 'commission_per_process',
    sortable: false,
    custom: true
  },
  { name: 'Ações', field: 'actions', sortable: false }
]
